export const viewStates = values => {
    return {
        startDateInFuture: false,
        showStartDateEditButton: false,
        showEndDateEditButton: true,
        showExpiryEditButton: true,
        showSubText: true,
        showDates: true,
        textGrayingStartDate: false,
        textGrayingEndDate: false,
        textGrayingExpiry: false,
        loansAndCopiesTextGraying: false,
        endDateExpired: false,
        grayingProductListItem: false,
        showActionButtons: true,
        allowStartDateEditing: false,
        allowExpiryEditing: true,
        ...values
    };
};

export const startDateInFuture = viewStates({
    startDateInFuture: true,
    showStartDateEditButton: true,
    showSubText: false,
    allowStartDateEditing: true
});

export const startDateReached = viewStates();

export const endDateReached = viewStates({
    textGrayingStartDate: true,
    loansAndCopiesTextGraying: true,
    endDateExpired: true,
    grayingProductListItem: true
});

export const autoExtendDateNotReached = viewStates({
    textGrayingStartDate: true,
    loansAndCopiesTextGraying: true,
    endDateExpired: true,
    showActionButtons: false
});

export const allEndDatesReached = viewStates({
    textGrayingStartDate: true,
    textGrayingEndDate: true,
    textGrayingExpiry: true,
    loansAndCopiesTextGraying: true,
    endDateExpired: true,
    showEndDateEditButton: false,
    showExpiryEditButton: false,
    grayingProductListItem: true,
    showActionButtons: false,
    allowExpiryEditing: false
});

export const startDateSetAndNoLoansLeft = viewStates({
    showEndDateEditButton: false,
    showExpiryEditButton: false,
    textGrayingStartDate: true,
    textGrayingEndDate: true,
    textGrayingExpiry: true,
    grayingProductListItem: true,
    loansAndCopiesTextGraying: true,
    allowExpiryEditing: false
});

export const noStartDateAndNoLoansLeft = viewStates({
    showDates: false,
    showEndDateEditButton: false,
    showExpiryEditButton: false,
    textGrayingStartDate: true,
    textGrayingEndDate: true,
    textGrayingExpiry: true,
    grayingProductListItem: true,
    loansAndCopiesTextGraying: true
});

export const noStartDateSet = viewStates({
    showDates: false,
    allowStartDateEditing: true
});
